
export const DiagnosticVisuel = ({ formData, resolver }: { formData: any, resolver: any }) => {
  // Extract risk levels from formData
  const risqueTable = formData?.['risque'] || {};

  // Get risk levels for each part, with fallback to 'faible'
  const houppierLevel = risqueTable['houppier'] || risqueTable['Houppier'] || 'faible';
  const troncLevel = risqueTable['tronc'] || risqueTable['Tronc'] || 'faible';
  const colletLevel = risqueTable['collet'] || risqueTable['Collet'] || 'faible';

  // Build the complete image path: {houppier}_{tronc}_{collet}_Complete.png
  const completeImagePath = `/images/Tree/complete/${houppierLevel}_${troncLevel}_${colletLevel}_Complete.png`;

  // Map the risk levels to an array format [racines, tronc, houppier]
  const risque = [houppierLevel, troncLevel, colletLevel];

  // Get the overall risk level for the evaluation bar
  const getOverallRiskLevel = () => {
    if (risque.includes('imminent')) return 'imminent';
    if (risque.includes('eleve')) return 'eleve';
    if (risque.includes('modere')) return 'modere';
    return 'faible';
  };

  const overallRisk = getOverallRiskLevel();

  // Risk color mapping
  const riskColors = {
    faible: 'bg-green-500',
    modere: 'bg-yellow-400',
    eleve: 'bg-red-500',
    imminent: 'bg-black'
  };

  return (


    <div className="w-[200px] h-[300px]">
      <img
        src={completeImagePath}
        alt={`Arbre - Houppier: ${houppierLevel}, Tronc: ${troncLevel}, Racines: ${colletLevel}`}
        className="w-[200px] h-[20rem] object-contain"
        onError={(e) => {
          console.error('Failed to load complete tree image:', completeImagePath);
          // Fallback: hide the image if it doesn't exist
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />

    </div>

  );
};
